<template>
  <div class="mobilePage">
    <div v-if="!isHarmony">
      <mxMobileVue @showWX="changeWXShow"></mxMobileVue>
      <vpnMobileVue @showWX="changeWXShow"></vpnMobileVue>
    </div>
    <harmony-mobileVue v-else @showWX="changeWXShow"></harmony-mobileVue>
    <wxDefaultVue v-if="isWXShow" @hideWX="changeWXShow"></wxDefaultVue>
  </div>
</template>
<script>
import mxMobileVue from '@/components/mxMobile.vue'
import vpnMobileVue from '@/components/vpnMobile.vue'
import harmonyMobileVue from '@/components/harmonyMobile.vue'
import wxDefaultVue from '@/views/wxDefault';
import device from '@/mx-service/libs/utils/device'

export default {
  components: {
    mxMobileVue,
    vpnMobileVue,
    harmonyMobileVue,
    wxDefaultVue
  },
  data(){
    return {
      isWXShow: false,
      isHarmony: device.isHarmony()
      // isHarmony: true
    }
  },
  methods: {
    changeWXShow(e){
      this.isWXShow = e
    }
  }
}
</script>
<style lang="less" scoped>
.mobilePage {
  width: 100%;
  height: 100%;
  overflow: scroll;
  background: linear-gradient(180deg, #D6EBFF 0%, #F9F9F9 81%, #FFFFFF 100%);
}
</style>